import React, { useState, useEffect } from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem
} from 'reactstrap'
import { Link } from 'react-scroll'
import './header.css'
import LocaleSwitcher from './localeSwitcher'

var Translate = require('react-translate-component')

function NavBar2 () {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)
  const logo = require('../Header/logo.png')
  const whitelogo = require('../Header/whitelogo.png')
  const logos = { logo, whitelogo }
  const [header, setHeader] = useState('header')

  const [selected, setSelected] = useState(logos.whitelogo)

  const listenScrollEvent = event => {
    if (window.scrollY < 73) {
      return setHeader('header')
    } else if (window.scrollY > 70) {
      return setHeader('header2')
    }
  }

  const listenScrollEvent2 = event => {
    if (window.scrollY < 73) {
      return setSelected(logos.whitelogo)
    } else if (window.scrollY > 70) {
      return setSelected(logos.logo)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent)
    window.addEventListener('scroll', listenScrollEvent2)

    return () => {window.removeEventListener('scroll', listenScrollEvent)
    window.removeEventListener('scroll', listenScrollEvent2)
  }}, [])

  return (

    <Navbar className={header} fixed='top' light expand='md'>
      <NavbarBrand className="logo">
        <a href={process.env.PUBLIC_URL + '/'}>
          <img src={selected} />
        </a>
      </NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse className='navbarItems' isOpen={isOpen} navbar>
        <Nav className='ml-auto' navbar>
          <NavItem>
            <Link
              className='nav-link'
              activeClass='customActive active'
              to='offers'
              spy={true}
              smooth={true}
              duration={500}
              offset={-89}
            >
              <Translate content='oferta' />
            </Link>
          </NavItem>
          <NavItem>
            <Link
              className='nav-link'
              activeClass='customActive active'
              // to='jumbotronAbout'
              spy={true}
              smooth={true}
              duration={500}
              offset={-89}
              href={process.env.PUBLIC_URL + '/#'}
            >
              <Translate content='o_nas' />
            </Link>
          </NavItem>
          <NavItem>
            <Link
              className='nav-link'
              activeClass='customActive active'
              to='projects'
              spy={true}
              smooth={true}
              duration={500}
              offset={-89}
            >
              <Translate content='realizacje' />
            </Link>
          </NavItem>
          <NavItem>
            <Link
              className='nav-link'
              activeClass='customActive active'
              to='partners_content'
              spy={true}
              smooth={true}
              duration={500}
              offset={-89}
            >
              <Translate content='zaufali_nam' />
            </Link>
          </NavItem>
          <NavItem className="navItemPadding">
            <Link
            
              id='nav-button'
              activeClass='customActive active'
              to='jumbotronContact'
              spy={true}
              smooth={true}
              duration={500}
              offset={-89}
            >
              <Translate content='kontakt' />
            </Link>
          </NavItem>
          <NavItem>
            <LocaleSwitcher  />
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  )
}

export default NavBar2
